"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TitleContainer = require("./TitleContainer.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 可設定標題跟內文的外框
 */
var TitleContainer = function TitleContainer(_ref) {
  var header = _ref.header,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_TitleContainer.UiTitleContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, children));
};

var _default = TitleContainer;
exports.default = _default;
TitleContainer.propTypes = {
  header: _propTypes.default.node,
  children: _propTypes.default.node
};